import moment from "moment";

const yearMonths = moment.months();
export const currentMonth = moment().month();
const monthsData = Array.apply(null, Array(currentMonth + 1)).map((_, index) => ({
    value: index,
    text: yearMonths[index],
}));

export const monthSelectOptions = {
    name: "month",
    type: "select",
    helpText: "",
    data: monthsData,
    validation: {
        required: false,
    },
};

export const currentYear = moment().year();
const YEARS_RANGE = 4;
const yearsData = Array.from(Array(YEARS_RANGE), (_, index) => {
    const year = `${currentYear - index}`;
    return { text: year, value: year };
});
export const yearSelectOptions = {
    ...monthSelectOptions,
    name: "year",
    data: yearsData,
};
